import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { products } from '../../../../shared/data/product-data';
import { ApplicationState } from '../../../../shared/state/application-state.service';

@Component({
  selector: 'app-discover',
  imports: [RouterModule],
  templateUrl: './discover.component.html',
  styleUrl: './discover.component.css',
})
export class DiscoverComponent implements OnInit {
  private readonly _destroying$ = new Subject<void>();
  private isInitialLoad = true;

  products = products.filter((product) => product.id != '');
  sections: NodeListOf<Element> | undefined;
  authenticated = inject(ApplicationState).isAuthenticated;

  router = inject(Router);
  activatedRoute = inject(ActivatedRoute);

  private observer: IntersectionObserver | undefined;

  constructor() {}

  ngOnInit(): void {
    this.activatedRoute.fragment.pipe(takeUntil(this._destroying$)).subscribe({
      next: (fragment: string | null) => {
        if (fragment) {
          this.scrollToFragment(fragment);
        } else if (this.isInitialLoad) {
          this.isInitialLoad = false;
        }
      },
    });
  }

  ngAfterViewInit() {
    this.sections = document.querySelectorAll('section');
    // console.log('sections', this.sections);
    const options = {
      root: null, // Use the viewport as the container
      rootMargin: '0px',
      threshold: 0.5, // Trigger callback when at least half of the section is visible
    };
    this.observer = new IntersectionObserver((entries) => {
      // allows to scroll to #fourth when clicking back
      if (this.isInitialLoad) return;

      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const id = entry.target.getAttribute('id');
          if (id) this.navigateWithFragment(id);
        }
      });
    }, options);

    setTimeout(() => {
      // Mark initial load as complete after delay, allows to scroll to #fourth when clicking back
      this.isInitialLoad = false;
      this.sections?.forEach((section) => {
        this.observer?.observe(section);
      });
    }, 1000);
  }

  navigateWithFragment(fragment: string) {
    this.router.navigate(['/discover'], {
      fragment: fragment,
      queryParamsHandling: 'merge',
    });
  }

  scrollToFragment(fragment: string | null) {
    if (fragment) {
      document.getElementById(fragment)?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
      });
      setTimeout(() => {
        this.isInitialLoad = false;
      }, 1500);
    }
  }

  goToProduct(product: string) {
    this.router.navigate([`/product/${product}`]);
  }

  ngOnDestroy(): void {
    this._destroying$.next();
    this._destroying$.complete();
    this.sections?.forEach((section) => {
      this.observer?.unobserve(section);
    });
    this.observer?.disconnect();
  }
}
